import type { UseFormProps } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import i18next from 'i18next';
import * as Yup from 'yup';
import { EXTERNAL_MANAGER_EMAIL_REGEX } from '@utils/YupUtil';

export type PasswordChangeFormType = {
  email: string;
};

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(EXTERNAL_MANAGER_EMAIL_REGEX, i18next.t('Member_Manager_17'))
    .required(i18next.t('Member_Group_Delete_05')),
});

export const PasswordChangeFormOptions: UseFormProps<PasswordChangeFormType> = {
  resolver: yupResolver(validationSchema),
  mode: 'onChange',
  shouldFocusError: true,
};
